import ClassItem from './ClassItem'

export default function ClassList({ title, listData }) {
  return (
    <section>
      <ClassItem title={title} listData={listData} />
    </section>
  )
}
